<div class="container container-extra main-container">
    <h1 class="page-title">
        <span>{{ 'POSITION.POSITIONS_TITLE' | translate }}</span>
    </h1>
    <div class="page-subtitle">{{ 'POSITION.POSITIONS_SUBTITLE' | translate }}</div>

    <mat-card class="card-light mb-4 search-box">
        <mat-card-header class="bold-title">
            <mat-card-title>
                <div class="panel-title">{{ 'POSITION.SEARCH' | translate }}</div>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="text-subtitle no-padding">
            <app-search #search
                [inlineButtons]="true"
                [isAllowSearch]="true"
                [placeholder]="'POSITION.POSITION_NAME' | translate"
                [config]="searchConfig"
                [showAddButton]="false"
                [isCustomAdd]="true"
                [isGroup]="true"
                [showClearButton]="true"
                [disabledAddButton]="true"
                (change)="onOptionClick($event)"
                >
            </app-search>

        </mat-card-content>
    </mat-card>

    <ng-container *ngIf="position">
        <app-position-data [mainForm]="mainForm" [expanded]="isPositionDataExpanded" [isAllowEdit]="isAllowEdit"></app-position-data>
        
        <app-position-profiles #profiles *ngIf="position?.id" [position]="position" (allValidChange)="onProfilesValidityChange($event)"></app-position-profiles>
    
        <app-position-questions *ngIf="position?.id" [position]="position"></app-position-questions>
    </ng-container>
    
    <mat-card class="card-review button-card">
        <mat-card-content class="action-panel">
            <div class="card-actions" *ngIf="hasPermissionToModify && !isAdd">
                <div class="button-panel"></div>
                <div class="button-panel">
                    <a mat-flat-button class="bt-add" color="primary" [routerLink]="['/position/add']" [disabled]="!isAllowAdd">{{ 'POSITION.ADD' | translate }}</a>
                    <button mat-flat-button class="bt-copy" color="primary" (click)="copy($event)" [disabled]="!isAllowCopy">{{ 'POSITION.COPY' | translate }}</button>
                    <button mat-flat-button class="bt-delete" color="primary" (click)="delete($event)" [disabled]="!isAllowDelete">{{ 'POSITION.DELETE' | translate }}</button>
                </div>
            </div>
            <div class="card-actions">
                <!-- <button mat-flat-button class="review-button button-bg-alt2" (click)="selectPosition($event)">Kiválasztás</button> -->
                <div class="button-panel">
                    <app-back-nav linkText="{{ 'POSITION.BACK' | translate }}"></app-back-nav>
                </div>

                <div class="button-panel">
                    <button mat-flat-button color="primary" (click)="ok($event)" *ngIf="isAllowEdit" [disabled]="!isAllowSave">{{ 'GENERAL.OK' | translate }}</button>
                    <button mat-flat-button color="primary" (click)="save($event)" *ngIf="isAllowEdit" [disabled]="!isAllowSave">{{ 'POSITION.SAVE' | translate }}</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

</div>
